<template>
  <div>
    <div :class="!isMenuView ? 'card mb-3 shadow chart-card mx-auto' : 'card shadow chart-card mx-auto'">
      <div class="chart-card-top card-body p-1">
        <div class="d-flex">
          <div v-if="!isMenuView" class="side-icons">
            <div @click="savePin">
              <font-awesome-icon :icon="['fas', 'thumb-tack']" :class=" this.chartCardObject.pin == 'Y' ? 'clicked-icon' : 'unclicked-icon'"/> 
            </div>
            <div v-if="!isDashboardView" @click="updateCardList(chartCardObject, $event)" :class=" isClientChartPartOfReportSetup(chartCardObject) == false ? 'unclicked-icon' : 'clicked-icon'">
              <font-awesome-icon v-tooltip="tooltipReportSetup" :icon="['fas', 'images']" style="height: 28px;" />
            </div>
          </div>
          <div v-if="!isDashboardCard()" :class="getChartCardClass()">
            <router-link :to="{ name: savedCardRouteName, params: { autoGenerateChart: true, saveClientChartId: this.chartCardObject.clientChartId } }">
              <img v-if="isCompetitiveProfileByMoat()" src="/img/castle-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />      
              <img v-if="isResponseRates()" src="/img/poll-people-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />      
              <img v-if="isCompetitiveProfileByValue()" src="/img/scale-unbalanced-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />                 
              <img v-if="isBattlecard()" :src="battlecardIcon" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="Battlecard" />
              <img v-else-if="isCompetitiveProfileBySalesWizard()" :src="stylesIcon" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="Styles" />
              <img v-if="isCompetitiveProfileByNeed()" src="/img/arrow-down-wide-short-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />   
              <img v-if="isCompetitiveProfileByWinners()" src="/img/road-duotone-solid.svg" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />
              <img v-else-if="isCompetitiveProfileByValueRoadmap() && !isRoadmapExplore() && !isPredictive()" src="/img/lift-map.svg" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="Lift Map" />
              <img v-if="isCompetitiveTrends() || isRoadmapExplore()"  src="/img/magnifying-glass-dollar.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />                 
              <img v-if="isProfileMatch()"  src="/img/code-compare-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />                               
              <img v-if="isMoatTrends()"  src="/img/display-chart-up-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />                 
              <img v-if="isPredictive()"  src="/img/hand-holding-circle-dollar-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />                 
              <div v-if="isWScoresRank" class="d-flex">
                <img v-if="isWScoresRank()" src="/img/wRatings-2021-W-support.png" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />
                <span v-if="isWScoresRank()">&#174;</span>
              </div>
              <img v-if="isCompetitiveProfileByMoneyballStick()" src="/img/moneyball.png" class="moneyball-stick-card" alt="wRatings" />
              <img v-if="isMoatRank()" src="/img/moneyball-ranks.png" class="moneyball-stick-card" alt="wRatings" />
              <img v-if="isEmotionsRank()" src="/img/heart-pulse-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />              
              <img v-if="isSatisfactionRank()" src="/img/arrow-up-9-1-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />              
              <img  v-if="isNPS()" src="/img/face-smile-duotone-solid.svg"  :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />              
              <img v-if="isNPSRank()" src="/img/face-viewfinder-duotone-solid.svg" width="40" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />
            </router-link>
            <img v-if="isDashboardCard()" src="/img/flag-checkered-duotone-solid.svg" width="40" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />
          </div>
          <div v-else :class="getChartCardClass()" @click="openSavedDashboardCard">
            <img v-if="isDashboardCard()" src="/img/flag-checkered-duotone-solid.svg" width="40" :class="isMenuView ? 'menu-support-card' : 'w-support-card'" alt="wRatings" />
          </div>
          <div v-if="isMenuView" class="chart-card-name pl-1 pr-1">
            <router-link :to="{ name: savedCardRouteName, params: { autoGenerateChart: true, saveClientChartId: this.chartCardObject.clientChartId } }">
              <span v-if="this.chartCardObject.name.length <= this.maximumCharacterCount"> {{ this.chartCardObject.name }} </span>
              <span v-else data-placement="bottom" :title="this.chartCardObject.name"> {{ this.chartCardObject.name.substring(0, this.maximumCharacterCount) + "...." }} </span>
            </router-link>
          </div>

          <div :class="!isMenuView ? 'ml-auto' : 'd-flex flex-column ml-auto'">
            <a load-on-starup="true" href="javascript:;" class="reload" @click="displayDeleteConfirmation">
              <font-awesome-icon :icon="['fas', 'window-close']" style="width: 20px;height: 20px;" />
            </a>
            <div v-if="isMenuView" @click="savePin">
              <font-awesome-icon :icon="['fas', 'thumb-tack']" :class=" this.chartCardObject.pin == 'Y' ? 'clicked-icon' : 'unclicked-icon'"/> 
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isDashboardCard() && !isMenuView" class="chart-card-row chart-card-name">
        <router-link :to="{ name: savedCardRouteName, params: { autoGenerateChart: true, saveClientChartId: this.chartCardObject.clientChartId } }">
          <span v-if="this.chartCardObject.name.length <= this.maximumCharacterCount"> {{ this.chartCardObject.name }} </span>
          <span v-else data-placement="bottom" :title="this.chartCardObject.name"> {{ this.chartCardObject.name.substring(0, this.maximumCharacterCount) + "...." }} </span>
        </router-link>
      </div>
      <div v-if="isDashboardCard() && !isMenuView" class="chart-card-row chart-card-name saved-dashboard-card" @click="openSavedDashboardCard">
          <span v-if="this.chartCardObject.name.length <= this.maximumCharacterCount"> {{ this.chartCardObject.name }} </span>
          <span v-else data-placement="bottom" :title="this.chartCardObject.name"> {{ this.chartCardObject.name.substring(0, this.maximumCharacterCount) + "...." }} </span>
      </div>
      <dashboard-value-road-map-modal 
          :modal-id="getModalId('dashboard-value-road-map')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-moneyball-stick-modal 
          :modal-id="getModalId('dashboard-moneyball-stick')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-moat-comps-modal 
          :modal-id="getModalId('dashboard-moat-comps')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-needs-profile-modal 
      :modal-id="getModalId('needs-profile')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-growth-sequence-modal 
          :modal-id="getModalId('growth-sequence')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-winners-map-modal 
          :modal-id="getModalId('winners-map')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-nps-trends-modal 
          :modal-id="getModalId('nps-trends')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-competitive-trends-modal 
          :modal-id="getModalId('dashboard-competitive-trends')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-competitive-rank-modal 
          :modal-id="getModalId('competitive-rank')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-respondent-map-modal 
          :modal-id="getModalId('respondent-map')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-performance-trends-modal 
          :modal-id="getModalId('performance-trends')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-rank-modal 
          :modal-id="getModalId('dashboard-nps-rank')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-rank-modal 
          :modal-id="getModalId('dashboard-moat-score-rank')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
      <dashboard-rank-modal 
          :modal-id="getModalId('dashboard-w-score-rank')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
          
<!--          
      <dashboard-saved-card-predictive-analytics-modal 
          :modal-id="getModalId('dashboard-predictive-analytics')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>
-->
      <dashboard-saved-card-predictive-analytics-contributions-modal 
          :modal-id="getModalId('dashboard-predictive-analytics')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>

      <dashboard-saved-card-predictive-analytics-contributions-modal 
          :modal-id="getModalId('dashboard-metric-contributions')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>

      <dashboard-metric-trends-modal 
          :modal-id="getModalId('dashboard-metric-trends')"
          :modal-title="chartCardObject.name"
          :client-object="$parent.$data.clientObject" 
          :save-client-chart-object="chartCardObject"/>

    </div>
  </div>
</template>
<script>
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";
import DashboardNeedsProfileModal from "../../modals/DashboardNeedsProfileModal.vue";
import DashboardGrowthSequenceModal from "../../modals/DashboardGrowthSequenceModal.vue";
import DashboardWinnersMapModal from "../../modals/DashboardWinnersMapModal.vue";
import DashboardNpsTrendsModal from "../../modals/DashboardNpsTrendsModal.vue";
import DashboardCompetitiveTrendsModal from "../../modals/DashboardCompetitiveTrendsModal.vue";
import DashboardCompetitiveRankModal from "../../modals/DashboardCompetitiveRankModal.vue";
import DashboardRespondentMapModal from "../../modals/DashboardRespondentMapModal.vue";
import DashboardRankModal from "../../modals/DashboardRankModal.vue";
import DashboardPerformanceTrendsModal from "../../modals/DashboardPerformanceTrendsModal.vue";
import DashboardSavedCardPredictiveAnalyticsContributionsModal from "../../modals/DashboardSavedCardPredictiveAnalyticsContributionsModal.vue";
import DashboardMoatCompsModal from "../../modals/DashboardMoatCompsModal.vue";
import DashboardMoneyballStickModal from "../../modals/DashboardMoneyballStickModal.vue";
import DashboardValueRoadMapModal from "../../modals/DashboardValueRoadMapModal.vue";
import DashboardMetricTrendsModal from "../../modals/DashboardMetricTrendsModal.vue";
import ChartService from "../../services/chart.service";
import AdminService from "../../services/admin.service";
import ReportService from "../../services/report.service";
import ClientChartService from "../../services/client.chart.service";
import SurveyService from "../../services/survey.service";
import ClientService  from "../../services/client.service";
import AlertService from "../../services/alert.service";
import battlecardIcon from "../../assets/img/sword_fill_icon.svg";
import stylesIcon from "../../assets/img/dstyles.svg";

export default {
  name: "ChartCard",
  mixins: [ContentMixins],
  components: {DashboardNeedsProfileModal,DashboardGrowthSequenceModal,DashboardWinnersMapModal,
    DashboardNpsTrendsModal,DashboardCompetitiveTrendsModal,DashboardCompetitiveRankModal,DashboardRankModal,
    DashboardRespondentMapModal,DashboardPerformanceTrendsModal,DashboardSavedCardPredictiveAnalyticsContributionsModal,DashboardValueRoadMapModal,
    DashboardMoatCompsModal,DashboardMoneyballStickModal,DashboardMetricTrendsModal},
  data() {
    return {
      maximumCharacterCount: 35,
      tooltipReportSetup: {
        placement: "right",
        content: "Click to include in printed reports",
        trigger: "hover",
        delay: { show: 500, hide: 500 },
      },
      updatedClientChartIds : this.clientChartIds,
      battlecardIcon,
      stylesIcon,
    };
  },
  props: {
    chartCardObject: {
      type: Object,
      default: function() {
        return {};
      }
    },
    clientChartIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    setType: {
      type: String,
      default: ""
    },
    viewType: {
      type: String,
      default: "cards"
    },       
  },
  computed: {
    isMenuView: function() {
      return this.viewType ==  "menu"
    },    
    isDashboardView: function() {
      return this.viewType ==  "dashboard"
    },    
    dashboardCardModalId: function(){
      return "dashboardCardId_"+this.setType+"_"+this.chartType.shortName+"_"+this.chartCardObject.clientChartId;
    },
    deleteConfirmationTitle: function() {
      return "Delete Confirmation for " + this.chartCardObject.name;
    },
    savedCardRouteName: function() {
      return this.isBattlecard() || this.isCompetitiveProfileBySalesWizard() ? "competitive-profile-wizard" : this.chartType.shortName;
    },
    chartType: function() {
      return ChartService.findChartTypeById(this.chartCardObject.chartTypeId);
    },
    surveyName() {
      return SurveyService.getNameBySurveyId(this.chartCardObject.surveyId);
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
  created() {},
  methods: {
    savePin: function(){
      let message = ClientService.displayPinMessage(this.chartCardObject, this.chartCardObject.name);
      let newPin = this.chartCardObject.pin == "N" ? "Y" : "N";
      this.$root.processServerRequest(message);
      ClientService.savePinForClientChart(this.chartCardObject.clientChartId, newPin, this.savePinCallback, this);
    },
    savePinCallback: function(response){
      this.$root.processServerResponse();      
      let message = response.data.message;
      AdminService.displaySuccessMessage({ text: message, duration: -1 });
      let clientCharts = response.data.data;
      this.$parent.entryClientObject.clientCharts = [...clientCharts];
      ClientService.saveClient(this.$parent.entryClientObject);
      this.$root.setClientObject(this.$parent.entryClientObject);
    },
    getModalId: function(shortName){
      return "dashboardCardId_"+this.setType+"_"+shortName+"_"+this.chartCardObject.clientChartId;
    },
    openSavedDashboardCard(){
      this.$modal.show(this.dashboardCardModalId);
    },
    isClientChartPartOfReportSetup(clientChart) {
      var match = this.clientChartIds.find(x => x.clientChartId === clientChart.clientChartId);
      if (typeof match !== "undefined") {
        return true;
      } 
      return false;
    },
    updateCardList(clientChart) {
      if (this.isClientChartPartOfReportSetup(clientChart)) {
        this.updatedClientChartIds.splice($.inArray(clientChart, this.clientChartIds), 1);
      } else {
        this.updatedClientChartIds.push(clientChart);
      }
      this.$emit('update', this.updatedClientChartIds);
    },
    displayDeleteConfirmation() {
      AlertService.showConfirmationMessageWithParameter(this.deleteClientChart,this.chartCardObject.clientChartId,this.deleteConfirmationTitle,'Are you sure you want delete ' + this.chartCardObject.name + ' ?');
    },
    deleteClientChartCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
        this.$emit("delete", this.chartCardObject.clientChartId);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    async deleteClientChart(result) {
      let clientChartId = result;
      this.$root.processServerRequest("Removing saved card");
      ClientChartService.deleteClientChart(clientChartId,this.deleteClientChartCallback,this);
    },
    getChartCardClass() {
      let returnClassName = !this.isMenuView ? "main-chart-icon ml-auto " : "main-chart-icon d-flex align-items-center ";
      if (this.isPredictive()) {
        returnClassName += "predictive-card";
      } else if (this.isRoadmapExplore()) {
        returnClassName += "competitive-trends-card";
      } else if (this.isCompetitiveProfileByValueRoadmap()) {
        returnClassName += "competitive-profile-by-value-roadmap-card";
      } else if (this.isCompetitiveProfileByMoneyballStick()) {
        returnClassName += "competitive-profile-by-moneyball-stick-card";
      } else if (this.isCompetitiveProfileByNeed()) {
        returnClassName += "competitive-profile-by-need-card";
      } else if (this.isCompetitiveProfileByMoat()) {
        returnClassName += "competitive-profile-by-moat-card";
      } else if (this.isCompetitiveProfileByValue()) {
        returnClassName += "competitive-profile-by-value-card";
      } else if (this.isCompetitiveProfileByWinners()) {
        returnClassName += "competitive-profile-by-winners-card";
      } else if (this.isCompetitiveProfileByNps()) {
        returnClassName += "competitive-profile-by-word-cloud-card";
      } else if (this.isCompetitiveTrends()) {
        returnClassName += "competitive-trends-card";
      } else if (this.isProfileMatch()) {
        returnClassName += "profile-match-card";
      } else if (this.isMoatRank()) {
        returnClassName += "moat-rank";
      } else if (this.isMoatTrends()) {
        returnClassName += "moat-trends-card";
      } else if (this.isWScoresRank()) {
        returnClassName += "w-scores-rank-card";
      } else if (this.isEmotionsRank()) {
        returnClassName += "emotions-rank-card";
      } else if (this.isSatisfactionRank()) {
        returnClassName += "satisfaction-rank-card";
      } else if (this.isNPSRank()) {
        returnClassName += "nps-rank-card";
      }  else if (this.isDashboardCard()) {
        returnClassName += "dashboard-saved-card";
      }
      return returnClassName;
    },
    isResponseRates() {
      return ChartService.isResponseRates(this.chartType.shortName);
    },
    isCompetitiveProfileByNeed() {
      return ChartService.isCompetitiveProfileByNeed(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileByMoat() {
      return ChartService.isCompetitiveProfileByMoat(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileBySalesWizard() {
      return ChartService.isCompetitiveProfileBySalesWizard(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isBattlecard() {
      return this.chartType.shortName === "battlecard";
    },
    isCompetitiveProfileByValue() {
      return ChartService.isCompetitiveProfileByValue(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileByWinners() {
      return ChartService.isCompetitiveProfileByWinners(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileByValueRoadmap () {
      return ChartService.isCompetitiveProfileByValueRoadmap(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileByMoneyballStick() {
      return ChartService.isCompetitiveProfileByMoneyballStick(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isCompetitiveProfileByNps() {
      return ChartService.isCompetitiveProfileByNPS(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isDashboardCard() {
      return ReportService.isSavedDashboardCard(this.chartType.chartTypeId);
    },
    isProfileMatch() {
      return ChartService.isProfileMatch(this.chartType.shortName);
    },
    isCompetitiveTrends() {
      return ChartService.isCompetitiveTrends(this.chartType.shortName);
    },
    isRoadmapExplore() {
      return this.chartType.shortName == "value-roadmap" && this.chartCardObject.displayType == "roadmap-explore";
    },
    isMoatRank() {
      return ChartService.isMoatRank(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isMoatTrends() {
      return ChartService.isMoatTrends(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isPredictive() {
      return ChartService.isPredictive(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isWScoresRank() {
      return ChartService.isWScoresRank(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isEmotionsRank() {
      return ChartService.isEmotionsRank(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isSatisfactionRank() {
      return ChartService.isSatisfactionRank(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isNPSRank() {
      return ChartService.isNPSRank(this.chartType.shortName, this.chartCardObject.displayType);
    },
    isNPS() {
      return ChartService.isNPS(this.chartType.shortName, this.chartCardObject.displayType);
    },    
  },
  watch: {}
};
</script>
